/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DataPointHistoryLocation } from './DataPointHistoryLocation';
import {
    DataPointHistoryLocationFromJSON,
    DataPointHistoryLocationFromJSONTyped,
    DataPointHistoryLocationToJSON,
    DataPointHistoryLocationToJSONTyped,
} from './DataPointHistoryLocation';
import type { PlumeOulinesGeometry } from './PlumeOulinesGeometry';
import {
    PlumeOulinesGeometryFromJSON,
    PlumeOulinesGeometryFromJSONTyped,
    PlumeOulinesGeometryToJSON,
    PlumeOulinesGeometryToJSONTyped,
} from './PlumeOulinesGeometry';

/**
 * Plume outline representation for the unmatched data map.
 * 
 * See `UnmatchedPlumeImageSerializer`.
 * @export
 * @interface UnmatchedPlumeOutline
 */
export interface UnmatchedPlumeOutline {
    /**
     * 
     * @type {string}
     * @memberof UnmatchedPlumeOutline
     */
    readonly id: string;
    /**
     * 
     * @type {PlumeOulinesGeometry}
     * @memberof UnmatchedPlumeOutline
     */
    geometry?: PlumeOulinesGeometry | null;
    /**
     * 
     * @type {DataPointHistoryLocation}
     * @memberof UnmatchedPlumeOutline
     */
    location: DataPointHistoryLocation;
    /**
     * 
     * @type {Array<string>}
     * @memberof UnmatchedPlumeOutline
     */
    readonly emissionRecordIds: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof UnmatchedPlumeOutline
     */
    readonly hasPlume: boolean;
    /**
     * 
     * @type {Date}
     * @memberof UnmatchedPlumeOutline
     */
    detectionTimestamp: Date;
    /**
     * 
     * @type {Array<Date>}
     * @memberof UnmatchedPlumeOutline
     */
    readonly matchedAt: Array<Date>;
    /**
     * If this should be hidden in the map by default.
     * @type {boolean}
     * @memberof UnmatchedPlumeOutline
     */
    readonly defaultHide: boolean;
}

/**
 * Check if a given object implements the UnmatchedPlumeOutline interface.
 */
export function instanceOfUnmatchedPlumeOutline(value: object): value is UnmatchedPlumeOutline {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('location' in value) || value['location'] === undefined) return false;
    if ((!('emissionRecordIds' in (value as Record<string, any>)) && !('emission_record_ids' in (value as Record<string, any>))) || ((value as Record<string, any>)['emissionRecordIds'] === undefined && (value as Record<string, any>)['emission_record_ids'] === undefined)) return false;
    if ((!('hasPlume' in (value as Record<string, any>)) && !('has_plume' in (value as Record<string, any>))) || ((value as Record<string, any>)['hasPlume'] === undefined && (value as Record<string, any>)['has_plume'] === undefined)) return false;
    if ((!('detectionTimestamp' in (value as Record<string, any>)) && !('detection_timestamp' in (value as Record<string, any>))) || ((value as Record<string, any>)['detectionTimestamp'] === undefined && (value as Record<string, any>)['detection_timestamp'] === undefined)) return false;
    if ((!('matchedAt' in (value as Record<string, any>)) && !('matched_at' in (value as Record<string, any>))) || ((value as Record<string, any>)['matchedAt'] === undefined && (value as Record<string, any>)['matched_at'] === undefined)) return false;
    if ((!('defaultHide' in (value as Record<string, any>)) && !('default_hide' in (value as Record<string, any>))) || ((value as Record<string, any>)['defaultHide'] === undefined && (value as Record<string, any>)['default_hide'] === undefined)) return false;
    return true;
}

export function UnmatchedPlumeOutlineFromJSON(json: any): UnmatchedPlumeOutline {
    return UnmatchedPlumeOutlineFromJSONTyped(json, false);
}

export function UnmatchedPlumeOutlineFromJSONTyped(json: any, ignoreDiscriminator: boolean): UnmatchedPlumeOutline {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'geometry': json['geometry'] === undefined ? undefined : json['geometry'] === null ? null : PlumeOulinesGeometryFromJSON(json['geometry']),
        'location': DataPointHistoryLocationFromJSON(json['location']),
        'emissionRecordIds': json['emission_record_ids'],
        'hasPlume': json['has_plume'],
        'detectionTimestamp': (new Date(json['detection_timestamp'])),
        'matchedAt': json['matched_at'],
        'defaultHide': json['default_hide'],
    };
}

export function UnmatchedPlumeOutlineToJSON(json: any): UnmatchedPlumeOutline {
    return UnmatchedPlumeOutlineToJSONTyped(json, false);
}

export function UnmatchedPlumeOutlineToJSONTyped(value?: Omit<UnmatchedPlumeOutline, 'id'|'emissionRecordIds'|'hasPlume'|'matchedAt'|'defaultHide'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'geometry': PlumeOulinesGeometryToJSON(value['geometry']),
        'location': DataPointHistoryLocationToJSON(value['location']),
        'detection_timestamp': value['detectionTimestamp'].toISOString(),
    };
}

